/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-09 14:31:11
 **/

import { RestAPIError } from "@/frameworks/libraries/restservice";
import { SystemError } from "@/frameworks/core/commons";
import { Configure } from "@/frameworks/libraries/utilities";
import { _T } from "@rfice/language";

const onGeneralErrorHandler = (name: string, error: RestAPIError) => {
	// console.debug("#useServiceState# generalError handler", name, error, "|", error.status, error.code);
	switch (error.code) {
		case "ERR_NETWORK":
		case "ERR_BAD_REQUEST": {
			new SystemError(_T("The server is unavailable. Please contact to administrator."), {
				errorType: "fatal",
				showToast: true,
				cause: {
					errorCode: error.code,
					errorMessage: _T("The server is unavailable. Please contact to administrator.")
				}
			});

			return true;
		}
	}

	switch (error.status) {
		case 401: {
			console.info("#useServiceState# Token has been expired");
			Configure.clear_authenticated();
			return true;
		}
	}
	return false;
};

export default onGeneralErrorHandler;
